import { render, staticRenderFns } from "./NewBatchBatchDetails.template.vue?vue&type=template&id=0349b59d&scoped=true&"
var script = {}
import style0 from "./NewBatchBatchDetails.template.vue?vue&type=style&index=0&id=0349b59d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0349b59d",
  null
  
)

export default component.exports